import { CQ } from "utils/commonQuest";
import { getQNConfig } from "utils/interface";
import cuid from "cuid";
import * as qiniu from "qiniu-js";
import { getFileDetailInfo } from "./fileMimeInfo";

// 获取文件信息
const getFileInfo = file => {
  let name: any, type: any, postfix: any;
  const lastIndex = file.name.lastIndexOf("."),
    fileType = file.type;

  name = file.name.substr(0, lastIndex);

  const fileInfo: any = getFileDetailInfo(fileType);
  if (fileInfo) {
    type = fileInfo.type;
    postfix = fileInfo.ext;
  } else {
    console.warn("上传了错误的文件", file);
  }
  // switch (fileType) {
  //   case "application/msword":
  //     type = "word";
  //     postfix = ".doc";
  //     break;
  //   case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
  //     type = "word";
  //     postfix = ".docx";
  //     break;
  //   case "application/vnd.ms-excel":
  //     type = "excel";
  //     postfix = ".xls";
  //     break;
  //   case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
  //     type = "excel";
  //     postfix = ".xls";
  //     break;
  //   case "text/plain":
  //     type = "txt";
  //     break;
  //   default:
  //     // 默认为txt类型
  //     if (fileType.indexOf("image/") != -1) type = "image";
  //     else type = "txt";
  //     break;
  // }
  return { name, type, postfix };
};

// 上传管理
export const uploadMg = {
  name: "uploadMg",
  state: {
    // 七牛云token
    token: "",
    // 资源域名
    domain: ""
  },
  reducers: {
    // 更新配置信息
    updConfig(state, data) {
      return {
        token: data.token,
        domain: data.domain
      };
    }
  },
  effects: {
    async uploadFile(payload: any, rootState: any) {
      const { data, res } = await CQ(getQNConfig(), true);
      if (res.code !== "0000") {
        console.log(res);
        payload.error("上传失败");
        return;
      }
      const { token, url } = data;
      this.updConfig(data);

      // 获取文件基本信息 文件名称，文件类型
      const { name, type, postfix } = getFileInfo(payload.file);
      // 生成七牛云文件指纹
      const key = cuid() + "." + postfix,
        file = payload.file;
      const config = {
        useCdnDomain: true,
        // 文件存储的七牛云区域
        region: qiniu.region.z0
      };

      const putExtra = {
        fname: name,
        params: {}
      };

      const observable = qiniu.upload(file, key, token, putExtra, config);
      observable.subscribe(
        (next: any) => {
          console.log("next");
        },
        (error: any) => {
          console.log(error);
          payload.error("上传失败");
        },
        (res: any) => {
          const fileUrl = url + "/" + res.key;
          console.log(fileUrl);
          payload.success({
            name,
            type,
            url: fileUrl
          });
        }
      );
    }
  }
};
